import angular from 'angular';

import translationsModuleName from '../../../../../lib/translation';

// Component
import component from './positionsPanels.component';
import './positionsPanels.css';

// Dependencies
import positionsPanelModule from '../positionsPanel';
import positionSearchServiceModule from '../../../../../lib/service/PositionSearchService';

const moduleName = 'staff.dashboardScreen.positionsPanels';
let module = angular.module(moduleName, [
  translationsModuleName,
  positionsPanelModule.name,
  positionSearchServiceModule.name,
]);

module.component('positionsPanels', component);

export default module;
